<template>
  <config-edit-view :entry-key="entryKey"></config-edit-view>
</template>

<script>
import asyncOperations from "@/client/extensions/composition/asyncOperations";
import ConfigEditView from "@/client/views/admin/config/Edit";
export default {
  name: "AdminConfigEdit",
  components: {
    ConfigEditView,
  },
  layout: "adminDashboard",
  middleware: {
    requireSuperAdmin: {},
  },
  props: {
    entryKey: {
      type: String,
      default: null,
    },
  },
  setup(props) {
    let { asyncOps, asyncOpsReady } = asyncOperations(props);
    return { asyncOps, asyncOpsReady };
  },
  meta: "",
  data: function () {
    return {};
  },
};
</script>

